import { Grow, NoSsr, Skeleton, SxProps } from "@mui/material";
import { ChevronRight } from "lucide-react";
import { useSwiper } from "swiper/react";
import SwiperNavigationButton from "./SwiperNavigationButton";

const SwiperPrevButton = ({ sx }: { sx?: SxProps }) => {
    const swiperRef = useSwiper();
    const styles: SxProps = {
        bottom: 16,
        top: 'unset',
        right: { xs: 'unset', sm: 16 + 42 + 16 },
        left: { xs: 16, sm: 'unset' },
        ...sx
    }


    return <NoSsr fallback={<Skeleton variant="circular" height={42} width={42} sx={{
        position: 'absolute',
        bgcolor: '#ffffff80',
        zIndex: 2,
        ...styles,
    }} />}>
        <Grow in={true}>
            <SwiperNavigationButton sx={styles}
                color="default"
                aria-label="اسلاید قبلی"
                onClick={() => {
                    swiperRef.slidePrev()
                }}>
                <ChevronRight size={23} />
            </SwiperNavigationButton>

        </Grow>
    </NoSsr>
}

export default SwiperPrevButton;